import { render } from "./RoomTypeNames.vue?vue&type=template&id=722b1e88"
import script from "./RoomTypeNames.vue?vue&type=script&lang=js"
export * from "./RoomTypeNames.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__